import { IOrderShippingAddress } from './order';

export class Cities {
  name: string;
  slug: string;
  type: string;
  name_with_type: string;
  code: string;

  constructor();
  constructor(obj?: Cities);
  constructor(obj?) {
    this.name = obj?.name || '';
    this.slug = obj?.slug || '';
    this.type = obj?.type || '';
    this.name_with_type = obj?.name_with_type || '';
    this.code = obj?.code || '';
  }
}

export class Districts extends Cities {
  path: string;
  path_with_type: string;
  parent_code: string;

  constructor();
  constructor(obj?: Districts);
  constructor(obj?) {
    super(obj);
    this.parent_code = obj?.parent_code || '';
    this.path = obj?.path || '';
    this.path_with_type = obj?.path_with_type || '';
  }
}

export class Wards extends Districts {}

export class Locations {
  cities: Cities[];
  wards: Wards[];
  constructor();
  constructor(obj?: Locations);
  constructor(obj?) {
    this.cities = obj?.cities || [];
    this.wards = obj?.wards || [];
  }

  getCitiesName(code: string) {
    return this.cities.filter((item) => item.code == code)?.[0]?.name;
  }

  getWardsName(code: string) {
    return this.wards.filter((item) => item.code == code)?.[0]?.name;
  }

  getFull(codeCities: string, codeWards: string) {
    return `${this.wards.filter((item) => item.code == codeWards)?.[0]?.name_with_type}, ${
      this.cities.filter((item) => item.code == codeCities)?.[0]?.name_with_type
    }`;
  }

  getOrderAddress(addressInfo: IOrderShippingAddress) {
    const address: string[] = [];

    if (addressInfo?.address) address.push(addressInfo.address);

    const ward = this.wards.find((item) => item.code == addressInfo?.ward);
    const pro = this.cities.find((item) => item.code == addressInfo?.city);

    if (ward?.name) address.push(ward?.name);
    if (pro?.name) address.push(pro?.name);

    return address.join(', ');
  }
}

export class AddressEntities {
  province: string;
  ward: string;
  street: string;

  constructor();
  constructor(obj?: AddressEntities);
  constructor(obj?) {
    this.province = obj?.province || '';
    this.ward = obj?.wards || '';
    this.street = obj?.street || '';
  }
}

export class Directions {
  id: string;
  translates: {
    vi: {
      name: string;
    };
    en: {
      name: string;
    };
  };
  constructor(obj?: Directions) {
    this.id = obj?.id || '';
    this.translates = {
      vi: {
        name: obj?.translates.vi.name || '',
      },
      en: {
        name: obj?.translates.en.name || '',
      },
    };
  }
}

export interface ILocation {
  cityCode: string;
  wardCode: string;
  address: string;
  mapEmbed: string;
}
